import { useEffect, useState } from 'react';
import { fetchExhibitionCountryCities } from './data/exhibitionCountryCitiesApi';
import {
  canonicalExhibitionCountry,
  isQueryableExhibitionCountry,
} from './data/exhibitionLocations';

/** Load the full city list for an exhibition country (API + cache, falls back to []). */
export function useExhibitionCountryCities(country) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const canonicalCountry = canonicalExhibitionCountry(country);
  const canQuery = isQueryableExhibitionCountry(country);

  useEffect(() => {
    if (!canonicalCountry || !canQuery) {
      setCities([]);
      setLoading(false);
      setError(null);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchExhibitionCountryCities(canonicalCountry)
      .then((list) => {
        if (!cancelled) {
          setCities(list);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setCities([]);
          setError(err instanceof Error ? err.message : 'Could not load cities');
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [canonicalCountry, canQuery]);

  return { cities, loading, error, canonicalCountry, canQuery };
}
